export function Target() {
    return (
        <section
            id="pour-qui"
            className="border-b border-slate-200 bg-white"
            data-testid="target-section"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16 py-14 md:py-24">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
                    <div className="lg:col-span-4">
                        <p className="reveal text-xs tracking-[0.18em] uppercase text-slate-500 mb-4">
                            02 — Public
                        </p>
                        <h2
                            className="reveal font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0B132B] font-medium leading-[1.05]"
                            data-testid="target-title"
                        >
                            Pour qui
                        </h2>
                    </div>
                    <div className="lg:col-span-7 lg:col-start-6">
                        <p
                            className="reveal text-base lg:text-lg text-slate-700 leading-relaxed max-w-2xl"
                            data-testid="target-body"
                        >
                            L'accompagnement s'adresse aux dirigeants,
                            indépendants, consultants, prestataires de
                            services, SCI, holdings familiales et structures
                            patrimoniales qui veulent mieux maîtriser leurs
                            données, leurs pratiques numériques et leurs
                            obligations courantes.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
